import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

const STAGING_FETCH_TIMEOUT_BUFFER = 800;

/**
 * Adjusts a fetch timeout value for the current environment.
 *
 * On staging, adds an extra 800ms buffer to account for slower infrastructure.
 * On prod, returns the value as-is.
 * Returns `undefined` for falsy values (e.g. 0), causing the SSR system to fall back to its default timeout.
 */
export function adjustSsrFetchTimeout(timeout: number): number | undefined {
	if (!timeout) {
		return undefined;
	}

	if (getMeta('ajs-environment') === 'staging') {
		return timeout + STAGING_FETCH_TIMEOUT_BUFFER;
	}

	return timeout;
}
